<br class="mt-2" />
<app-title [title]="'Pedido realizado'" style="margin-top: 3rem; margin-bottom: 1rem"></app-title>

<div class="row col-xs-12 mt-4 ml-3">
  <h4 class="black">Detalle del pedido</h4>
</div>

<hr style="margin-bottom: 3rem; margin-top: 0" />

<div class="finshdOrdrContGrid">
  <div class="textAlCenter">
    <h2>
      ¡Tu pedido ha sido realizado con
      <a
        [routerLink]="
          {
            cxRoute: 'orderDetails',
            params: orderFromHistory
          } | cxUrl
        "
        class="orderSuccesT"
        >éxito!</a
      >
    </h2>
  </div>
  <div class="pedidoRealizadoContainer" style="text-align: center">
    <img src="/assets/img/pedido-realizado.png" alt="" />
  </div>
  <div class="ordrContainer">
    <div class="readyOrderCot lightGrey">
      <ng-container *ngIf="orders.length; else noOrder">
        <div class="mt-3 cotNumberTitle">
          <p class="bold" *ngIf="orders.length == 1">Tu número de pedido es</p>
          <p class="bold" *ngIf="orders.length > 1">Tus números de pedido son</p>
        </div>
        <div class="cotNumber" *ngFor="let order of orders">
          <h1 class="textPrimaryBlue">{{ order }}</h1>
        </div>
      </ng-container>
      <ng-template #noOrder>
        <div class="mt-3 cotNumberTitle">
          <p class="bold">Tu número de pedido es</p>
        </div>
        <div class="cotNumber">
          <h1 class="textPrimaryBlue">{{ orderFromHistory.code }}</h1>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="ordrBtnCont">
    <div class="gridBtnsCont">
      <div class="start">
        <button class="mt-3 btn btn-secondary" [routerLink]="{ cxRoute: 'home' } | cxUrl">Continuar Comprando</button>
      </div>
      <div class="end">
        <button class="mt-3 btn btn-primary" [routerLink]="{ cxRoute: 'orders' } | cxUrl">Ir a mis pedidos</button>
      </div>
    </div>
  </div>
</div>

<br class="mt-2" />
<!-- TODO: modify static links -->
